document.addEventListener('DOMContentLoaded', () => {

  /* Toggle password visibility */
//   document.addEventListener('click', e => {
//     const toggle = e.target.closest('[data-toggle-password]');
//     if (!toggle) return;

//     const wrap = toggle.closest('.password-input-wrap');
//     const input = wrap.querySelector('input');

//     const hidden = input.type === 'password';
//     input.type = hidden ? 'text' : 'password';
//     toggle.classList.toggle('is-visible', hidden);
//   });

  /* Strength + confirm */
  document.addEventListener('input', () => {
    const wrap = document.querySelector('[data-password-wrapper]');
    if (!wrap) return;

    const pwd = wrap.querySelector('[data-password-input]');
    const confirm = document.querySelector('[data-password-confirm]');
    const bar = wrap.querySelector('.password-strength__bar');
    const text = wrap.querySelector('.password-strength__text');
    const submit = document.querySelector('[data-signup-submit]');
    const error = document.querySelector('[data-password-error]');

    let score = 0;
    const val = pwd.value;

    if (val.length >= 8) score++;
    if (/[A-Z]/.test(val)) score++;
    if (/[0-9]/.test(val)) score++;
    if (/[^A-Za-z0-9]/.test(val)) score++;

    bar.style.width = `${score * 25}%`;
    if (score <= 1) {
        bar.style.background = '#d32f2f';
        text.textContent = 'Weak';
    } else if (score <= 3) {
        bar.style.background = '#f9a825';
        text.textContent = 'Medium';
    } else {
        bar.style.background = '#2e7d32';
        text.textContent = 'Strong';
    }

    const match =
      confirm.value === val &&
      confirm.value.length > 0;

    error.hidden = match || confirm.value.length === 0;
    submit.disabled = !(score >= 2 && match);
  });

});
